export { default as routes } from './routes'



// WEBPACK FOOTER //
// ./src/app/domains/knowledge_area/index.js